export default __webpack_public_path__ + "static/AeonikPro-Regular-68fccbe01a5a75cec0069103e998baec.woff2";